import React, { useState } from 'react';
import { ModalBase } from './ModalBase';

interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const countryData = [
  {
    name: 'Alemania',
    flag: '🇩🇪',
    traffic: {
      speed: 'Ciudad: 50 km/h | Carretera: 100 km/h | Autopista: Recomendada 130 km/h (sin límite en tramos).',
      alcohol: '0.5 g/L (0.0 g/L para noveles y profesionales).',
      lights: 'Recomendadas durante el día. Obligatorias con baja visibilidad.',
      safetyEquipment: 'Chaleco reflectante, triángulo de preseñalización, botiquín de primeros auxilios.',
      notes: 'Pegatinas medioambientales (Umweltplakette) en muchas ciudades. Prohibido usar apps de aviso de radares.'
    },
    connectivity: {
      mobile: 'Excelente cobertura 4G/5G. Operadores: Deutsche Telekom, Vodafone, O2. Roaming UE.',
      internet: 'Fibra (VDSL/FTTH) y cable muy extendidos. Starlink disponible.'
    },
    languages: {
      main: 'Alemán',
      secondary: 'Inglés (muy extendido).'
    }
  },
  {
    name: 'Andorra',
    flag: '🇦🇩',
    traffic: {
      speed: 'Ciudad: 40 km/h | Carretera: 90 km/h.',
      alcohol: '0.5 g/L (0.2 g/L para noveles/profesionales).',
      lights: 'Uso obligatorio en túneles.',
      safetyEquipment: 'Cadenas o neumáticos de invierno obligatorios del 1 de noviembre al 15 de mayo.',
      notes: 'País montañoso con carreteras sinuosas. Aparcamiento regulado (zona azul).'
    },
    connectivity: {
      mobile: 'Buena cobertura (Andorra Telecom). Roaming puede ser caro (no es UE).',
      internet: 'Excelente, con 100% de cobertura de fibra óptica.'
    },
    languages: {
      main: 'Catalán',
      secondary: 'Español, Francés, Portugués.'
    }
  },
  {
    name: 'Austria',
    flag: '🇦🇹',
    traffic: {
      speed: 'Ciudad: 50 km/h | Carretera: 100 km/h | Autopista: 130 km/h.',
      alcohol: '0.5 g/L (0.1 g/L para noveles/profesionales).',
      lights: 'Luces de cruce recomendadas durante el día.',
      safetyEquipment: 'Chaleco reflectante (para el conductor), triángulo, botiquín.',
      notes: 'Viñeta (Vignette) obligatoria para circular en autopistas y autovías.'
    },
    connectivity: {
      mobile: 'Buena cobertura 4G/5G. Operadores: A1, Magenta, Drei. Roaming UE.',
      internet: 'Buena disponibilidad de fibra y cable en ciudades. Starlink disponible.'
    },
    languages: {
      main: 'Alemán',
      secondary: 'Inglés.'
    }
  },
  {
    name: 'Bélgica',
    flag: '🇧🇪',
    traffic: {
      speed: 'Ciudad: 50 km/h | Carretera: 90 km/h (70 en Flandes) | Autopista: 120 km/h.',
      alcohol: '0.5 g/L (0.2 g/L para profesionales).',
      lights: 'Luces de cruce recomendadas.',
      safetyEquipment: 'Chaleco reflectante, triángulo, extintor.',
      notes: 'La prioridad a la derecha es fundamental. Zonas de bajas emisiones (LEZ) en Bruselas, Amberes y Gante.'
    },
    connectivity: {
      mobile: 'Buena cobertura 4G/5G. Operadores: Proximus, Orange, Telenet. Roaming UE.',
      internet: 'Extensa red de cable y fibra. Starlink disponible.'
    },
    languages: {
      main: 'Neerlandés, Francés, Alemán',
      secondary: 'Inglés.'
    }
  },
  {
    name: 'Bulgaria',
    flag: '🇧🇬',
    traffic: {
      speed: 'Ciudad: 50 km/h | Carretera: 90 km/h | Autopista: 140 km/h.',
      alcohol: '0.5 g/L.',
      lights: 'Obligatorias todo el día, todo el año.',
      safetyEquipment: 'Triángulo, botiquín, extintor, chaleco reflectante.',
      notes: 'Viñeta (Vinetka) electrónica obligatoria para usar casi todas las carreteras.'
    },
    connectivity: {
      mobile: 'Buena cobertura en ciudades, variable en zonas rurales. Roaming UE.',
      internet: 'Buena conexión en ciudades. Starlink es una buena opción rural.'
    },
    languages: {
      main: 'Búlgaro',
      secondary: 'Inglés, Ruso, Alemán (en zonas turísticas).'
    }
  },
  {
    name: 'Chipre',
    flag: '🇨🇾',
    traffic: {
      speed: 'Ciudad: 50 km/h | Carretera: 80 km/h | Autopista: 100 km/h.',
      alcohol: '0.22 mg/L (aire).',
      lights: 'Obligatorias media hora después del atardecer y hasta media hora antes del amanecer.',
      safetyEquipment: '2 triángulos de preseñalización.',
      notes: 'Se conduce por la izquierda. Las matrículas rojas indican coche de alquiler.'
    },
    connectivity: {
      mobile: 'Buena cobertura. Roaming UE.',
      internet: 'Fibra en desarrollo, buena conexión en zonas turísticas.'
    },
    languages: {
      main: 'Griego, Turco',
      secondary: 'Inglés (muy extendido).'
    }
  },
  {
    name: 'Croacia',
    flag: '🇭🇷',
    traffic: {
      speed: 'Ciudad: 50 km/h | Carretera: 90 km/h | Autopista: 130 km/h.',
      alcohol: '0.5 g/L (0.0 g/L para noveles y profesionales).',
      lights: 'Obligatorias durante el día en horario de invierno (último domingo de octubre al último de marzo).',
      safetyEquipment: 'Chaleco, 2 triángulos, botiquín, bombillas de repuesto (para luces no LED/xenón).',
      notes: 'Peajes en la mayoría de las autopistas. En caso de accidente, es obligatorio llamar a la policía.'
    },
    connectivity: {
      mobile: 'Buena cobertura, especialmente en la costa. Operadores: Hrvatski Telekom, A1, Telemach. Roaming UE.',
      internet: 'Buena en zonas turísticas. Starlink disponible.'
    },
    languages: {
      main: 'Croata',
      secondary: 'Inglés, Alemán, Italiano (en zonas turísticas).'
    }
  },
  {
    name: 'Dinamarca',
    flag: '🇩🇰',
    traffic: {
      speed: 'Ciudad: 50 km/h | Carretera: 80 km/h | Autopista: 130 km/h.',
      alcohol: '0.5 g/L.',
      lights: 'Luces de cruce obligatorias durante todo el día.',
      safetyEquipment: 'Triángulo de preseñalización.',
      notes: 'Mucho cuidado con los ciclistas, tienen carriles y prioridad. Peajes en los puentes Storebælt y Øresund.'
    },
    connectivity: {
      mobile: 'Excelente cobertura. Roaming UE.',
      internet: 'Excelente conectividad, fibra muy extendida.'
    },
    languages: {
      main: 'Danés',
      secondary: 'Inglés (excelente nivel general).'
    }
  },
  {
    name: 'Eslovaquia',
    flag: '🇸🇰',
    traffic: {
      speed: 'Ciudad: 50 km/h | Carretera: 90 km/h | Autopista: 130 km/h.',
      alcohol: '0.0 g/L (tolerancia cero).',
      lights: 'Luces de cruce obligatorias durante todo el día.',
      safetyEquipment: 'Chaleco reflectante (al alcance del conductor), triángulo, botiquín.',
      notes: 'Viñeta electrónica obligatoria para autopistas.'
    },
    connectivity: {
      mobile: 'Buena cobertura. Roaming UE.',
      internet: 'Buena en ciudades. Starlink disponible.'
    },
    languages: {
      main: 'Eslovaco',
      secondary: 'Checo, Inglés.'
    }
  },
  {
    name: 'Eslovenia',
    flag: '🇸🇮',
    traffic: {
      speed: 'Ciudad: 50 km/h | Carretera: 90 km/h | Autopista: 130 km/h.',
      alcohol: '0.5 g/L (0.0 g/L para noveles/profesionales).',
      lights: 'Luces de cruce obligatorias durante todo el día.',
      safetyEquipment: 'Chaleco reflectante, triángulo, botiquín, bombillas de repuesto.',
      notes: 'Viñeta electrónica obligatoria para autopistas (e-vignette).'
    },
    connectivity: {
      mobile: 'Buena cobertura. Roaming UE.',
      internet: 'Buena conectividad, fibra extendida.'
    },
    languages: {
      main: 'Esloveno',
      secondary: 'Inglés, Italiano, Húngaro (en sus respectivas regiones).'
    }
  },
  {
    name: 'España',
    flag: '🇪🇸',
    traffic: {
      speed: 'Ciudad: 20/30/50 km/h según vía | Carretera: 90 km/h | Autopista/Autovía: 120 km/h.',
      alcohol: '0.5 g/L (0.3 g/L para noveles y profesionales).',
      lights: 'Obligatorias en túneles y con baja visibilidad.',
      safetyEquipment: '2 triángulos de preseñalización (o luz V-16), chaleco reflectante.',
      notes: 'Zonas de Bajas Emisiones (ZBE) en ciudades >50.000 hab. (se requiere etiqueta). Peajes en autopistas.'
    },
    connectivity: {
      mobile: 'Excelente cobertura 4G/5G. Operadores: Movistar, Vodafone, Orange. Roaming UE.',
      internet: 'Red de fibra (FTTH) muy extendida. Starlink es una opción en áreas rurales.'
    },
    languages: {
      main: 'Español (Castellano)',
      secondary: 'Catalán, Gallego, Euskera (cooficiales). Inglés y Francés en zonas turísticas.'
    }
  },
  {
    name: 'Estonia',
    flag: '🇪🇪',
    traffic: {
      speed: 'Ciudad: 50 km/h | Carretera: 90 km/h | Autopista: 110 km/h (verano).',
      alcohol: '0.2 g/L.',
      lights: 'Luces de cruce obligatorias durante todo el día.',
      safetyEquipment: '2 calzos para las ruedas, triángulo, extintor, botiquín.',
      notes: 'Neumáticos de invierno obligatorios en temporada.'
    },
    connectivity: {
      mobile: 'Excelente cobertura 4G, 5G en expansión. Roaming UE.',
      internet: 'País muy digitalizado, excelente conexión en ciudades.'
    },
    languages: {
      main: 'Estonio',
      secondary: 'Ruso, Inglés.'
    }
  },
  {
    name: 'Finlandia',
    flag: '🇫🇮',
    traffic: {
      speed: 'Ciudad: 50 km/h | Carretera: 80-100 km/h | Autopista: 120 km/h (verano).',
      alcohol: '0.5 g/L.',
      lights: 'Luces de cruce obligatorias durante todo el día.',
      safetyEquipment: 'Triángulo de preseñalización.',
      notes: 'Neumáticos de invierno obligatorios. Cuidado con alces y renos cruzando la carretera.'
    },
    connectivity: {
      mobile: 'Excelente cobertura. Roaming UE.',
      internet: 'Excelente conectividad, líder en Europa.'
    },
    languages: {
      main: 'Finlandés, Sueco',
      secondary: 'Inglés (excelente nivel).'
    }
  },
  {
    name: 'Francia',
    flag: '🇫🇷',
    traffic: {
      speed: 'Ciudad: 50 km/h | Carretera: 80 km/h | Autopista: 130 km/h (110 si llueve).',
      alcohol: '0.5 g/L (0.2 g/L para noveles).',
      lights: 'Recomendadas de día, obligatorias de noche o con baja visibilidad.',
      safetyEquipment: 'Chaleco reflectante, triángulo, alcoholímetro (recomendado).',
      notes: 'Viñeta Crit\'Air necesaria en algunas ciudades (ZFE). Peajes en la mayoría de autopistas.'
    },
    connectivity: {
      mobile: 'Excelente cobertura 4G/5G. Operadores: Orange, SFR, Bouygues. Roaming UE.',
      internet: 'Extensa red de fibra (FTTH). Starlink disponible.'
    },
    languages: {
      main: 'Francés',
      secondary: 'Inglés (en zonas turísticas).'
    }
  },
  {
    name: 'Grecia',
    flag: '🇬🇷',
    traffic: {
      speed: 'Ciudad: 50 km/h | Carretera: 90 km/h | Autopista: 130 km/h.',
      alcohol: '0.5 g/L (0.2 g/L para noveles/profesionales).',
      lights: 'No son obligatorias durante el día.',
      safetyEquipment: 'Triángulo, botiquín, extintor.',
      notes: 'Peajes en autopistas. Se requiere carnet de conducir internacional para no residentes de la UE.'
    },
    connectivity: {
      mobile: 'Buena cobertura en el continente e islas principales. Roaming UE.',
      internet: 'Fibra en expansión en Atenas y Tesalónica. ADSL común.'
    },
    languages: {
      main: 'Griego',
      secondary: 'Inglés, Alemán (en turismo).'
    }
  },
  {
    name: 'Hungría',
    flag: '🇭🇺',
    traffic: {
      speed: 'Ciudad: 50 km/h | Carretera: 90 km/h | Autopista: 130 km/h.',
      alcohol: '0.0 g/L (tolerancia cero).',
      lights: 'Obligatorias todo el día fuera de poblado.',
      safetyEquipment: 'Chaleco, triángulo, botiquín.',
      notes: 'Viñeta electrónica (matrica) obligatoria para autopistas y carreteras nacionales.'
    },
    connectivity: {
      mobile: 'Buena cobertura 4G. Roaming UE.',
      internet: 'Buena en ciudades. Starlink disponible.'
    },
    languages: {
      main: 'Húngaro',
      secondary: 'Inglés, Alemán.'
    }
  },
  {
    name: 'Irlanda',
    flag: '🇮🇪',
    traffic: {
      speed: 'Ciudad: 50 km/h | Carretera Regional: 80 km/h | Carretera Nacional: 100 km/h | Autopista: 120 km/h.',
      alcohol: '0.5 g/L (0.2 g/L para noveles/profesionales).',
      lights: 'Recomendadas. Obligatorias con baja visibilidad.',
      safetyEquipment: 'No hay equipamiento obligatorio para vehículos extranjeros.',
      notes: 'Se conduce por la izquierda. Peaje sin barreras en la M50 de Dublín (se paga online).'
    },
    connectivity: {
      mobile: 'Buena cobertura. Operadores: Eir, Vodafone, Three. Roaming UE.',
      internet: 'Fibra muy extendida. Starlink es popular en zonas rurales.'
    },
    languages: {
      main: 'Inglés, Irlandés (Gaélico)',
      secondary: 'Polaco.'
    }
  },
  {
    name: 'Italia',
    flag: '🇮🇹',
    traffic: {
      speed: 'Ciudad: 50 km/h | Carretera: 90 km/h | Autopista: 130 km/h.',
      alcohol: '0.5 g/L (0.0 g/L para noveles/profesionales).',
      lights: 'Obligatorias de día fuera de poblado y en autopistas.',
      safetyEquipment: 'Chaleco reflectante, triángulo.',
      notes: 'Zonas de Tráfico Limitado (ZTL) en centros históricos, ¡mucho cuidado! Peajes en autopistas.'
    },
    connectivity: {
      mobile: 'Buena cobertura. Operadores: TIM, Vodafone, Wind Tre. Roaming UE.',
      internet: 'Fibra extendida en el norte y ciudades. Starlink disponible.'
    },
    languages: {
      main: 'Italiano',
      secondary: 'Inglés, Francés, Alemán (en zonas turísticas y fronterizas).'
    }
  },
  {
    name: 'Letonia',
    flag: '🇱🇻',
    traffic: {
      speed: 'Ciudad: 50 km/h | Carretera: 90 km/h.',
      alcohol: '0.5 g/L (0.2 g/L para noveles).',
      lights: 'Luces de cruce obligatorias durante todo el día.',
      safetyEquipment: 'Chaleco, triángulo, botiquín, extintor.',
      notes: 'Neumáticos de invierno obligatorios del 1 de diciembre al 1 de marzo.'
    },
    connectivity: {
      mobile: 'Buena cobertura 4G/5G. Roaming UE.',
      internet: 'Muy buena velocidad y disponibilidad en ciudades.'
    },
    languages: {
      main: 'Letón',
      secondary: 'Ruso, Inglés.'
    }
  },
  {
    name: 'Liechtenstein',
    flag: '🇱🇮',
    traffic: {
      speed: 'Ciudad: 50 km/h | Carretera: 80 km/h.',
      alcohol: '0.5 g/L.',
      lights: 'Luces de cruce obligatorias durante todo el día.',
      safetyEquipment: 'Triángulo de preseñalización.',
      notes: 'Utiliza la viñeta suiza para sus tramos de autopista. País muy pequeño, fácil de recorrer.'
    },
    connectivity: {
      mobile: 'Excelente cobertura (usa redes suizas). Roaming puede ser caro (no es UE).',
      internet: 'Excelente conectividad.'
    },
    languages: {
      main: 'Alemán',
      secondary: 'Inglés.'
    }
  },
  {
    name: 'Lituania',
    flag: '🇱🇹',
    traffic: {
      speed: 'Ciudad: 50 km/h | Carretera: 90 km/h | Autopista: 130 km/h (verano).',
      alcohol: '0.4 g/L (0.0 g/L para noveles/profesionales).',
      lights: 'Luces de cruce obligatorias durante todo el día.',
      safetyEquipment: 'Chaleco, triángulo, botiquín, extintor.',
      notes: 'Neumáticos de invierno obligatorios del 10 de noviembre al 1 de abril.'
    },
    connectivity: {
      mobile: 'Buena cobertura 4G/5G. Roaming UE.',
      internet: 'Excelente velocidad y cobertura, especialmente de fibra.'
    },
    languages: {
      main: 'Lituano',
      secondary: 'Ruso, Polaco, Inglés.'
    }
  },
  {
    name: 'Luxemburgo',
    flag: '🇱🇺',
    traffic: {
      speed: 'Ciudad: 50 km/h | Carretera: 90 km/h | Autopista: 130 km/h.',
      alcohol: '0.5 g/L (0.2 g/L para noveles/profesionales).',
      lights: 'Obligatorias en túneles.',
      safetyEquipment: 'Triángulo de preseñalización.',
      notes: 'El transporte público es gratuito en todo el país. Precios de combustible suelen ser más bajos.'
    },
    connectivity: {
      mobile: 'Excelente cobertura. Roaming UE.',
      internet: 'Excelente conectividad, fibra muy extendida.'
    },
    languages: {
      main: 'Luxemburgués, Francés, Alemán',
      secondary: 'Inglés, Portugués.'
    }
  },
  {
    name: 'Malta',
    flag: '🇲🇹',
    traffic: {
      speed: 'Ciudad: 50 km/h | Carretera: 80 km/h.',
      alcohol: '0.8 g/L (0.2 g/L para noveles/profesionales).',
      lights: 'No obligatorias de día.',
      safetyEquipment: 'Triángulo de preseñalización.',
      notes: 'Se conduce por la izquierda. Distancias cortas pero tráfico muy denso y carreteras estrechas.'
    },
    connectivity: {
      mobile: 'Buena cobertura. Roaming UE.',
      internet: 'Buena conectividad.'
    },
    languages: {
      main: 'Maltés, Inglés',
      secondary: 'Italiano.'
    }
  },
  {
    name: 'Mónaco',
    flag: '🇲🇨',
    traffic: {
      speed: 'Ciudad: 50 km/h.',
      alcohol: '0.5 g/L.',
      lights: 'Obligatorias en los numerosos túneles.',
      safetyEquipment: 'Chaleco reflectante, triángulo.',
      notes: 'Tráfico muy denso. Aparcamiento subterráneo es la mejor opción. Prohibido circular con ciertos vehículos en algunas zonas.'
    },
    connectivity: {
      mobile: 'Excelente cobertura (Monaco Telecom, usa red francesa). Roaming puede ser caro.',
      internet: 'Excelente conectividad de fibra.'
    },
    languages: {
      main: 'Francés',
      secondary: 'Inglés, Italiano, Monegasco.'
    }
  },
  {
    name: 'Países Bajos',
    flag: '🇳🇱',
    traffic: {
      speed: 'Ciudad: 50 km/h | Carretera: 80 km/h | Autopista: 100 km/h (130 km/h de 19:00 a 06:00).',
      alcohol: '0.5 g/L (0.2 g/L para noveles).',
      lights: 'No obligatorias de día.',
      safetyEquipment: 'Triángulo de preseñalización.',
      notes: 'Mucha atención a los ciclistas, tienen prioridad absoluta. No hay peajes excepto en algunos túneles.'
    },
    connectivity: {
      mobile: 'Excelente cobertura. Roaming UE.',
      internet: 'Excelente conectividad, fibra y cable muy extendidos.'
    },
    languages: {
      main: 'Neerlandés',
      secondary: 'Inglés (excelente nivel).'
    }
  },
  {
    name: 'Polonia',
    flag: '🇵🇱',
    traffic: {
      speed: 'Ciudad: 50 km/h | Carretera: 90 km/h | Autopista: 140 km/h.',
      alcohol: '0.2 g/L.',
      lights: 'Luces de cruce obligatorias durante todo el día.',
      safetyEquipment: 'Triángulo, extintor.',
      notes: 'Peajes en algunas autopistas (sistema e-TOLL).'
    },
    connectivity: {
      mobile: 'Buena cobertura 4G. Roaming UE.',
      internet: 'Buena en ciudades. Starlink disponible.'
    },
    languages: {
      main: 'Polaco',
      secondary: 'Inglés, Alemán.'
    }
  },
  {
    name: 'Portugal',
    flag: '🇵🇹',
    traffic: {
      speed: 'Ciudad: 50 km/h | Carretera: 90 km/h | Autopista: 120 km/h.',
      alcohol: '0.5 g/L (0.2 g/L para noveles/profesionales).',
      lights: 'No obligatorias de día.',
      safetyEquipment: 'Chaleco reflectante (dentro del habitáculo), triángulo.',
      notes: 'Sistema de peajes electrónicos muy extendido (EasyToll, Tollcard). Prohibido usar detectores de radar.'
    },
    connectivity: {
      mobile: 'Buena cobertura. Operadores: MEO, NOS, Vodafone. Roaming UE.',
      internet: 'Extensa red de fibra. Starlink disponible.'
    },
    languages: {
      main: 'Portugués',
      secondary: 'Inglés, Español, Francés (en turismo).'
    }
  },
  {
    name: 'Reino Unido',
    flag: '🇬🇧',
    traffic: {
      speed: 'Ciudad: 30 mph (48 km/h) | Carretera: 60 mph (96 km/h) | Autopista: 70 mph (112 km/h).',
      alcohol: '0.8 g/L (0.5 g/L en Escocia).',
      lights: 'Obligatorias con baja visibilidad.',
      safetyEquipment: 'No obligatorio para vehículos extranjeros, pero recomendado.',
      notes: 'Se conduce por la izquierda. Tasa de congestión en Londres. Cuidado con cámaras de velocidad media (average speed cameras).'
    },
    connectivity: {
      mobile: 'Buena cobertura 4G/5G. Operadores: EE, O2, Vodafone. Roaming puede tener costes post-Brexit.',
      internet: 'Buena disponibilidad de fibra y cable. Starlink disponible.'
    },
    languages: {
      main: 'Inglés',
      secondary: 'Galés (en Gales), Gaélico escocés (en Escocia).'
    }
  },
  {
    name: 'República Checa',
    flag: '🇨🇿',
    traffic: {
      speed: 'Ciudad: 50 km/h | Carretera: 90 km/h | Autopista: 130 km/h.',
      alcohol: '0.0 g/L (tolerancia cero).',
      lights: 'Luces de cruce obligatorias durante todo el día.',
      safetyEquipment: 'Chaleco, triángulo, botiquín.',
      notes: 'Viñeta electrónica obligatoria para autopistas.'
    },
    connectivity: {
      mobile: 'Buena cobertura. Roaming UE.',
      internet: 'Buena conectividad en ciudades.'
    },
    languages: {
      main: 'Checo',
      secondary: 'Eslovaco, Inglés, Alemán.'
    }
  },
  {
    name: 'Rumanía',
    flag: '🇷🇴',
    traffic: {
      speed: 'Ciudad: 50 km/h | Carretera: 90-100 km/h | Autopista: 130 km/h.',
      alcohol: '0.0 g/L (tolerancia cero).',
      lights: 'Obligatorias de día en autopistas y carreteras nacionales.',
      safetyEquipment: 'Chaleco, 2 triángulos, botiquín, extintor.',
      notes: 'Viñeta (rovinieta) obligatoria para todas las carreteras nacionales. Calidad de carreteras variable.'
    },
    connectivity: {
      mobile: 'Buena cobertura en ciudades. Roaming UE.',
      internet: 'Velocidades muy altas en ciudades, variable en zonas rurales.'
    },
    languages: {
      main: 'Rumano',
      secondary: 'Húngaro, Inglés, Francés.'
    }
  },
  {
    name: 'Suecia',
    flag: '🇸🇪',
    traffic: {
      speed: 'Ciudad: 50 km/h | Carretera: 70 km/h | Autopista: 110-120 km/h.',
      alcohol: '0.2 g/L.',
      lights: 'Luces de cruce obligatorias durante todo el día.',
      safetyEquipment: 'Triángulo de preseñalización.',
      notes: 'Neumáticos de invierno obligatorios (1 Dic - 31 Mar). Tasas de congestión en Estocolmo y Gotemburgo.'
    },
    connectivity: {
      mobile: 'Excelente cobertura. Roaming UE.',
      internet: 'Excelente conectividad.'
    },
    languages: {
      main: 'Sueco',
      secondary: 'Inglés (excelente nivel).'
    }
  },
  {
    name: 'Suiza',
    flag: '🇨🇭',
    traffic: {
      speed: 'Ciudad: 50 km/h | Carretera: 80 km/h | Autopista: 120 km/h.',
      alcohol: '0.5 g/L (0.1 g/L para profesionales).',
      lights: 'Luces de cruce obligatorias durante todo el día.',
      safetyEquipment: 'Triángulo (al alcance del conductor).',
      notes: 'Viñeta anual obligatoria para autopistas. Muchos radares.'
    },
    connectivity: {
      mobile: 'Excelente cobertura. Roaming caro (no es UE). Comprar SIM local es recomendable.',
      internet: 'Excelente conectividad.'
    },
    languages: {
      main: 'Alemán, Francés, Italiano',
      secondary: 'Inglés.'
    }
  }
];

const Section: React.FC<{title: string; icon: string; children: React.ReactNode}> = ({title, icon, children}) => (
    <div className="mt-5">
        <h4 className="text-lg font-semibold text-gray-800 flex items-center mb-3">
            <span className="material-icons-outlined mr-3 text-blue-600 w-6 text-center">{icon}</span>
            {title}
        </h4>
        <div className="pl-9 space-y-3 border-l-2 border-gray-200 ml-3">
            {children}
        </div>
    </div>
);

const DetailItem: React.FC<{label: string; children: React.ReactNode}> = ({label, children}) => (
    <div>
        <dt className="font-semibold text-gray-700">{label}:</dt>
        <dd className="text-gray-600 text-sm">{children}</dd>
    </div>
);


const CountryAccordion: React.FC<{ country: typeof countryData[0], isOpen: boolean, onClick: () => void }> = ({ country, isOpen, onClick }) => (
    <div className="border border-gray-200 rounded-lg transition-shadow duration-300 hover:shadow-md bg-white">
        <h2>
            <button
                type="button"
                className="flex justify-between items-center w-full p-4 text-left font-bold text-xl text-gray-800 bg-gray-50 hover:bg-gray-100 rounded-lg"
                onClick={onClick}
                aria-expanded={isOpen}
            >
                <span className="flex items-center">
                    <span className="text-3xl mr-3">{country.flag}</span>
                    {country.name}
                </span>
                <svg
                    className={`w-6 h-6 transform transition-transform duration-300 text-gray-500 ${isOpen ? 'rotate-180' : ''}`}
                    fill="none" stroke="currentColor" viewBox="0 0 24 24"
                >
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7" />
                </svg>
            </button>
        </h2>
        <div className={`overflow-hidden transition-all duration-500 ease-in-out ${isOpen ? 'max-h-[1000px]' : 'max-h-0'}`}>
            <div className="p-5 border-t border-gray-200">
                
                <Section title="Normas de Tráfico" icon="traffic">
                    <DetailItem label="Límites de velocidad">{country.traffic.speed}</DetailItem>
                    <DetailItem label="Tasa de alcoholemia">{country.traffic.alcohol}</DetailItem>
                    <DetailItem label="Uso de luces">{country.traffic.lights}</DetailItem>
                    <DetailItem label="Equipamiento de seguridad">{country.traffic.safetyEquipment}</DetailItem>
                    <DetailItem label="Notas importantes">{country.traffic.notes}</DetailItem>
                </Section>

                <Section title="Conectividad" icon="signal_cellular_alt">
                    <DetailItem label="Telefonía Móvil">{country.connectivity.mobile}</DetailItem>
                    <DetailItem label="Internet">{country.connectivity.internet}</DetailItem>
                </Section>

                 <Section title="Idiomas" icon="language">
                    <DetailItem label="Principal">{country.languages.main}</DetailItem>
                    <DetailItem label="Secundario">{country.languages.secondary}</DetailItem>
                </Section>
            </div>
        </div>
    </div>
);


export const CountryGuideModal: React.FC<ModalProps> = ({ isOpen, onClose }) => {
    const [openCountryName, setOpenCountryName] = useState<string | null>(null);
    const [searchTerm, setSearchTerm] = useState('');

    const handleToggle = (name: string) => {
        setOpenCountryName(openCountryName === name ? null : name);
    };

    const filteredCountries = countryData
        .filter(country => country.name.toLowerCase().includes(searchTerm.toLowerCase()))
        .sort((a, b) => a.name.localeCompare(b.name));

    return (
        <ModalBase isOpen={isOpen} onClose={onClose} title="Guía de Viaje por País" mainClassName="bg-gray-50">
            <p className="mb-4 text-lg text-gray-600">
                Conducir por Europa es una gran experiencia, pero cada país tiene sus propias reglas. Usa el buscador para encontrar un país o explora la lista.
            </p>
            
            <div className="sticky top-0 bg-gray-50 py-4 mb-4 z-10">
                 <input
                    type="text"
                    placeholder="Buscar país..."
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    className="w-full px-4 py-2.5 border border-gray-300 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500 transition-colors"
                />
            </div>

            <div className="space-y-3">
                {filteredCountries.length > 0 ? (
                    filteredCountries.map((country) => (
                        <CountryAccordion
                            key={country.name}
                            country={country}
                            isOpen={openCountryName === country.name}
                            onClick={() => handleToggle(country.name)}
                        />
                    ))
                ) : (
                    <p className="text-center text-gray-500 py-8">No se encontraron países con ese nombre.</p>
                )}
            </div>
            <p className="mt-6 text-xs text-gray-500 text-center">
                <strong>Aviso:</strong> Esta información es orientativa y puede estar sujeta a cambios. Consulta siempre las normativas locales vigentes antes de viajar.
            </p>
        </ModalBase>
    );
};
